import microuniversoApi from "app/api/microuniversoApi";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { PerfilButtonContainer } from "app/components/perfil-button/PerfilButtonContainer";
import { removerComponenteReact, renderizarComponentReact } from "app/components/renderizarOuRemoverComponentReact";
import { SenhaVendedorContainerDialog } from "app/components/senha-vendedor/SenhaVendedorContainerDialog";
import { Separador } from "app/components/separador/Separador";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { DadosClasseProduto, PesquisaClasse } from "./PesquisaClasse";

export type PesquisaClasseContainerProps = {
  onVoltar: () => void,
  passos: Dict<string, () => void>
  regiaoRenderizada: string
  onSelecionadoClasse: (classe: string) => void,
}

export const PesquisaClasseContainer = (props: PesquisaClasseContainerProps) => {
  const [dados, setDados] = useState<any>();


  const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))


  const listaClassesProduto = async () => {
    try {
      globalMU.blockUI();
      const resposta = await microuniversoApi.Produto.listarClassesProdutos();

      if ("Unauthorized" in resposta) {
        renderizarComponentReact(<SenhaVendedorContainerDialog
          onRenderizarAposAutentificar={() => {
            removerComponenteReact("botao-perfil-react")
            renderizarComponentReact(<PesquisaClasseContainer {...props} />, props.regiaoRenderizada, true)
            renderizarComponentReact(<PerfilButtonContainer />, "botao-perfil-react", false)
          }}
          onVoltar={props.onVoltar}
        />, "senha-vendedor-container-dialog", true);

        return
      }

      handleFormatData(resposta);

    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const handleFormatData = (data: DadosClasseProduto[]) => {
    const dataPerLevel = [];

    for (const element of data) {
      Array.isArray(dataPerLevel[element.Nivel - 1])
        ? dataPerLevel[element.Nivel - 1].push(element)
        : (dataPerLevel[element.Nivel - 1] = [element]);
    }

    for (let i = 0; i < dataPerLevel.length; i++) {
      if (dataPerLevel.length === i + 1) {
        break;
      }
      if (!dataPerLevel[i]) {
        continue;
      }
      for (let j = 0; j < dataPerLevel[i].length; j++) {
        const element = dataPerLevel[i][j];
        let aux = i + 1;
        while (!dataPerLevel[aux] && aux < dataPerLevel.length) {
          aux++;
        }

        for (let k = 0; k < dataPerLevel[aux].length; k++) {
          const elementNextArray = dataPerLevel[aux][k];
          if (elementNextArray.Hierarquia.startsWith(element.Hierarquia)) {
            Array.isArray(element.Filhos)
              ? element.Filhos.push(elementNextArray)
              : (element.Filhos = [elementNextArray]);
          }
        }
      }
    }
    setDados(dataPerLevel[0]);
  };

  const onPassoSelecionado = (passo: string) => {
    passosInterno.current.get(passo)()
  }

  const onVoltar = () => {
    props.onVoltar()
  }

  useEffect(() => {
    passosInterno.current.set("Pesquisar Classes", () => { })
    listaClassesProduto();
  }, []);


  return (
    <>
      <Breadcrumb2Container
        passos={passosInterno.current.keysToList()}
        exibirBotaoLimpar={false}
        exibirBotaoVoltar={true}
        id="PesquisaClasseContainer"
        onPassoSelecionado={onPassoSelecionado}
        onBotaoVoltarClicado={onVoltar}
      />

      <Separador />

      <PesquisaClasse
        classesProdutos={dados}
        onClasseSelecionada={(codigoClasse) => {
          props.onSelecionadoClasse(codigoClasse)
        }}
      />
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};
